import React, {Component} from "react";
import PropTypes from "prop-types";
import PaidUsers from "./PaidUsers/PaidUsers";
import UserByPlans from "./UserByPlans/UserByPlans";

class StatisticsPage extends Component {
    render() {
        return (
            <div className="StatisticsPage">
                <h1>Statistics</h1>

                <UserByPlans/>
                <PaidUsers/>
            </div>
        );
    }
}

StatisticsPage.propTypes = {
    any: PropTypes.any
};

export default StatisticsPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/statistic/StatisticsPage.js